import { useMemo, useEffect, useState } from "react";
import { useAppSelector } from "../../framework/redux/hooks";
import { makeSelectWorkShiftsByDate } from "../../framework/redux/slices/workShiftSlice";
import { Base } from "../../framework/common/base";

export const useSelectWorkShiftsByDate = (
    rangeStart: string,
    rangeEnd: string
) => {
    const state = useAppSelector((state) => state.workShift);

    const selectWorkShiftsByDate = useMemo(makeSelectWorkShiftsByDate, []);
    return selectWorkShiftsByDate(state, rangeStart, rangeEnd);
};

export const useSelectCurrentWorkShift = () => {
    return useAppSelector((state) => state.workShift.current);
};

export const useIsWaitingForPlannedShift = () => {
    const shift = useAppSelector((state) => state.workShift.current);
    const [, setForceUpdate] = useState(0);

    const isWaiting = Boolean(
        shift?.startTimePlannedWorkShiftId &&
        Base.isAfter(shift.startTime, new Date())
    );

    useEffect(() => {
        if (!shift?.startTimePlannedWorkShiftId) return;
        const interval = setInterval(() => {
            setForceUpdate(prev => prev + 1);
            if (!Base.isAfter(shift?.startTime, new Date())) {
                clearInterval(interval);
            }
        }, 10000);
        return () => clearInterval(interval);
    }, [shift?.startTimePlannedWorkShiftId, shift?.startTime]);

    return isWaiting;
};
